import { Injectable } from '@angular/core';
import { UserFilter } from '@shared/entities/userFilter';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable, shareReplay, Subject, switchMap, take, tap } from 'rxjs';

const LOG_PREFIX = '[Api][CompanyGroupUsersFilters] ';

export interface CompanyGroupUsersFilterURL {
  companyGroupId?: string;
  role?: string;
  keyword?: string;
  accountId?: string;
  serialNumber?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CompanyGroupUsersFiltersService extends ApiService<UserFilter> {
  private _refresh$: Subject<boolean>;
  all$: Observable<UserFilter>;
  currentFilters: CompanyGroupUsersFilterURL = {};

  set filters(value: CompanyGroupUsersFilterURL) {
    this.currentFilters = value;
    this.refresh(true);
  }

  constructor() {
    const masterUrl = '/users/filters';
    const detailUrl = '/users/filters';

    super(UserFilter, masterUrl, detailUrl);

    this._refresh$ = new BehaviorSubject<boolean>(true);

    this.all$ = this._refresh$.pipe(
      switchMap(() => {
        if (this.currentFilters.companyGroupId) {
          this.setUrlParameter('companyGroupId', this.currentFilters.companyGroupId);
        } else {
          this.removeUrlParameter('companyGroupId');
        }
        if (this.currentFilters.role) {
          this.setUrlParameter('role', this.currentFilters.role);
        } else {
          this.removeUrlParameter('role');
        }
        if (this.currentFilters.keyword) {
          this.setUrlParameter('keyword', this.currentFilters.keyword);
        } else {
          this.removeUrlParameter('keyword');
        }
        if (this.currentFilters.accountId) {
          this.setUrlParameter('accountId', this.currentFilters.accountId);
        } else {
          this.removeUrlParameter('accountId');
        }
        if (this.currentFilters.serialNumber) {
          this.setUrlParameter('serialNumber', this.currentFilters.serialNumber);
        } else {
          this.removeUrlParameter('serialNumber');
        }
        return this.findOne('');
      }),
      tap({
        next: (result) => this.logger.debug(LOG_PREFIX + 'all$', result),
        error: (err) => this.logger.error(LOG_PREFIX + 'all$ error', err)
      }),
      shareReplay(1)
    );
  }

  refresh(value: boolean) {
    this.logger.debug(LOG_PREFIX + 'refresh');
    this._refresh$.next(value);

    return this.all$.pipe(take(1));
  }
}